<page-load-header *ngIf="!initialized"></page-load-header>
<div *ngIf="initialized" >
  <div class="row">
    <div *ngFor="let exhibit of exhibits" class="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3 cbp-item graphic">
      <div class="cbp-item-wrapper">
        <a *ngIf="exhibit.published" class="cbp-caption" [routerLink]="['../sponsors/landing-pages', exhibit.sponsorOrganizationId]">
          <img *ngIf="exhibit.sponsorshipLogo" class="rounded img-fluid" src="fetchimage?filename={{ exhibit.sponsorshipLogo }}&width=500&height=334"  />
          <img *ngIf="!exhibit.sponsorshipLogo" class="rounded img-fluid" src="https://via.placeholder.com/500x334?text={{ exhibit.title }}"  />
          <div class="py-3">
            <h4 class="h6 text-dark mb-0">{{ exhibit.title }}</h4>
            <p class="small mb-0">
              {{ exhibit.subtitle }}
            </p>
          </div>
        </a>

        <div *ngIf="!exhibit.published">
          <img *ngIf="exhibit.sponsorshipLogo" class="rounded img-fluid" src="fetchimage?filename={{ exhibit.sponsorshipLogo }}&width=500&height=334"  />
          <img *ngIf="!exhibit.sponsorshipLogo" class="rounded img-fluid" src="https://via.placeholder.com/500x334?text={{ exhibit.title }}"  />
          <div class="py-3">
            <h4 class="h6 text-dark mb-0">{{ exhibit.title }}</h4>
            <p class="small mb-0">
              {{ exhibit.subtitle }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
